import { ISectionFeeVm } from "@app/core/services/WebRegApiClient";
import { createAction, props } from "@ngrx/store";

export const loadSectionFeesBySectionId = createAction(
  "[SectionFees Effect] Load SectionFees By SectionId",
  props<{ peSectionId: number }>()
);

export const sectionFeesInserted = createAction(
  "[SectionFees Effect] SectionFees Loaded",
  props<{ sectionFees: ISectionFeeVm, peSectionId: number }>()
);
